import { ModelIndexedDB } from "@/models/ModelIndexedDB";
import { addMagicMethods } from "@/helpers/addMagicMethods";
export class ImageModel extends ModelIndexedDB {
    constructor(id = null) {
        super('images', +id);
        return addMagicMethods(this);
    }
}
